export const fallbackLng = 'en';
export const languages = [fallbackLng];

export function getOptions(lng = fallbackLng) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
  };
}
